import { PureComponent } from 'react'
import { getJSON } from '../../common/services/api'
import Modal from '.'
import PopupModal from './PopupModal'
import MedicationForm from '../forms/popups/MedicationForm'
// @ts-ignore
import { withRouter, RouteComponentProps } from '../../withRouter'

interface Medication {
  searchValue: string
  label: string
  value: string
}

interface AddMedicationModalProps extends RouteComponentProps {
  createItem: (data: { onComplete: () => void; url: string; json: any }) => void
  fetchList: (list: string, filters: any) => void
  fields: any
  showToast: (options: { title: string }) => void
  isOpen: boolean
}

export class AddMedicationModal extends PureComponent<AddMedicationModalProps> {
  state = {
    medicationsList: null as Medication[] | null,
  }

  componentDidUpdate(prevProps: AddMedicationModalProps) {
    const { isOpen } = this.props
    if (!this.state.medicationsList && !prevProps.isOpen && isOpen) {
      this.fetchMedicationsList()
    }
  }

  fetchMedicationsList = async () => {
    try {
      const json = await getJSON({
        url: `/api/services/nhs/medications`,
      })
      const medicationsList: Medication[] = json.result.map((name: string) => ({
        searchValue: name.toLowerCase(),
        label: name,
        value: name,
      }))
      this.setState({ medicationsList })
    } catch (e) {
      console.log(e)
    }
  }

  handleSubmit = () => {
    const {
      createItem,
      fetchList,
      fields,
      // @ts-ignore
      router: { params },
      showToast,
    } = this.props

    createItem({
      onComplete: () => {
        showToast({ title: 'Added a Medication' })
        fetchList('medications', { filters: { resident: params.id } })
      },
      url: `list/medications`,
      json: {
        ...fields,
        resident: params.id,
      },
    })
  }

  render() {
    const { fields, isOpen, ...formProps } = this.props

    if (!fields || !isOpen) return null

    return (
      <PopupModal
        confirmText="Add"
        list="Medication"
        buttonIcon="plus"
        buttonColour="success"
        onConfirm={this.handleSubmit}
        {...formProps}
        type="create"
      >
        <MedicationForm
          fields={fields}
          formId={MODAL_ID}
          medicationsList={this.state.medicationsList}
        />
      </PopupModal>
    )
  }
}

const MODAL_ID = 'addMedication'

export default Modal(withRouter(AddMedicationModal), MODAL_ID)
